import type { LucideIcon } from 'lucide-react'
import { Building2, Clock, Globe2, MapPin, Tags, Briefcase, Laptop } from 'lucide-react'

import type { FilterOption } from '@/components/filters/filter-menu'
import { CURRENT_CLIENT } from '@/constants'
import { EMPLOYMENT_TYPE_LABELS, WORK_MODE_LABELS } from '@/utils/job-meta-labels'

export { EMPLOYMENT_TYPE_LABELS, WORK_MODE_LABELS }

export type JobPostedSince = '24h' | '7d' | '30d'
export type JobSourceKind = 'managed' | 'marketplace'

export const POSTED_SINCE_LABELS: Record<JobPostedSince, string> = {
  '24h': 'Last 24 hours',
  '7d': 'Last 7 days',
  '30d': 'Last 30 days',
}

/** Posted window picker order: all time, then increasing time windows (day → week → month). */
export const POSTED_SINCE_OPTION_ORDER: readonly (JobPostedSince | '')[] = [
  '',
  '24h',
  '7d',
  '30d',
]

export const POSTED_SINCE_ALL_LABEL = 'All'

export const SOURCE_KIND_LABELS: Record<JobSourceKind, string> = {
  managed: CURRENT_CLIENT.name || 'Hosted',
  marketplace: 'Adzuna',
}

export {
  UNIFIED_EMPLOYMENT_FILTER_OPTIONS as EMPLOYMENT_FILTER_OPTIONS,
  UNIFIED_WORK_MODE_FILTER_OPTIONS as WORK_MODE_FILTER_OPTIONS,
} from '@/lib/list-filters/job-meta-filter-options'

export const POSTED_SINCE_FILTER_OPTIONS: FilterOption[] = POSTED_SINCE_OPTION_ORDER.map(
  (value) => ({
    value,
    label: value ? POSTED_SINCE_LABELS[value] : POSTED_SINCE_ALL_LABEL,
  }),
)

export const SOURCE_FILTER_OPTIONS: FilterOption[] = (
  Object.keys(SOURCE_KIND_LABELS) as JobSourceKind[]
).map((value) => ({
  value,
  label: SOURCE_KIND_LABELS[value],
}))

export const CANDIDATE_JOBS_FILTER_ICONS: Record<string, LucideIcon> = {
  skills: Tags,
  work_mode: Laptop,
  employment_type: Briefcase,
  posted: Clock,
  source: Globe2,
  organisation: Building2,
  location: MapPin,
}

export const WORK_MODE_SET = new Set<string>(Object.keys(WORK_MODE_LABELS))
export const EMPLOYMENT_TYPE_SET = new Set<string>(Object.keys(EMPLOYMENT_TYPE_LABELS))
export const POSTED_SINCE_SET = new Set<string>(Object.keys(POSTED_SINCE_LABELS))
export const SOURCE_KIND_SET = new Set<string>(Object.keys(SOURCE_KIND_LABELS))

/** Shared with employer jobs browse — API `sort` query param. */
export type CandidateJobsSort = 'updated_desc' | 'updated_asc' | 'title_asc' | 'title_desc'

export const CANDIDATE_JOBS_SORT_LABELS: Record<CandidateJobsSort, string> = {
  updated_desc: 'Recently updated',
  updated_asc: 'Oldest updated',
  title_asc: 'Title A–Z',
  title_desc: 'Title Z–A',
}

export const CANDIDATE_JOBS_SORT_OPTIONS: FilterOption[] = (
  Object.keys(CANDIDATE_JOBS_SORT_LABELS) as CandidateJobsSort[]
).map((key) => ({
  value: key,
  label: CANDIDATE_JOBS_SORT_LABELS[key],
}))
